import HourlyMain from "@components/HourlyMain";
const Hourly: React.FC = () => {
  return (
    <Container>
      <HourlyMain />
    </Container>
  );
};

export default Hourly;
